module.exports = __webpack_public_path__ + "static/img/CO.121b3089.svg";